import contentCarousel from "./content-carousel";

function inItVerticalTab() {
  var $verticalTab = $(".vertical-tab"),
    $verticalTabList,
    $verticalTabListItem,
    $verticalTabListItemContent,
    $verticalTabListItemLink,
    $verticalTabListItemTarget,
    $verticalTabContent;

  $verticalTabList = $verticalTab.find(".vertical-tab__list");
  $verticalTabContent = $verticalTab.find(".veritcal-tab__content");
  $verticalTabListItem = $verticalTab.find(".vertical-tab__item");
  $verticalTabListItemContent = $verticalTab.find(
    ".vertical-tab__item-content"
  );
  $verticalTabListItemLink = $verticalTab.find(".vertical-tab__item a");

  //click on vertical tab item
  $verticalTabListItemLink.click(function() {
    //Remove active class from item
    $verticalTabListItem.removeClass("active");

    //Add active class to current item
    $(this)
      .parent()
      .addClass("active");

    //Get data-target
    $verticalTabListItemTarget = $(this).data("target");

    //Remove inactive tab content
    $verticalTabListItemContent.removeClass("active");
    $($verticalTabListItemTarget).addClass("active");
  });
}

//Contentcard Carousel
function inItContentCardCarousel() {
  var swiper = new Swiper(".contentCard__container", {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },

    breakpoints: {
      767: {
        slidesPerView: 1
      }
    }
  });
}

(function() {
  //Call if card carousel component exist on page
  if ($(".vertical-tab").length) {
    //Initialize Vertical tab
    inItVerticalTab();
  }

  (function() {
    //Call if card carousel component exist on page
    if ($(".contentCard__wrapper").length) {
      //Initialize carousel
      inItContentCardCarousel();

      $(".contentCard__container").each(function(){
        var sliderCount = $(this).children().find(".swiper-slide").length;
        if(sliderCount <= 1){
          $(this).find(".contentCard__pagination").hide();
        }
      })
    }
  })();
})();
